export default __webpack_public_path__ + "static/img6_conditional_question-6d4ccdef7ac6e71a7ded36a9bab8517b.png";